import { Form } from 'react-bootstrap';
import styled from 'styled-components';

export default styled(Form.Group)`
    position: relative;
`